import { AgGridTable } from '@shared/components/ui/AgGridTable';
import type { CustomColDef } from '@shared/components/ui/AgGridTable';
import type { WithdrawalPaymentFile } from '../../models';

interface WithdrawalPaymentFilesAgGridTableProps {
  paymentFiles: WithdrawalPaymentFile[];
  columnDefs: CustomColDef[];
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
}

export const WithdrawalPaymentFilesAgGridTable = ({
  paymentFiles,
  columnDefs,
  fetchNextPage,
  hasNextPage = false,
  isFetchingNextPage = false,
}: WithdrawalPaymentFilesAgGridTableProps) => {
  return (
    <AgGridTable
      data={paymentFiles}
      columnDefs={columnDefs}
      height="calc(100vh - 140px)"
      enableSelection={false}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
    />
  );
};
